import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Col, Drawer, Modal, Row, Spin, Tooltip } from 'antd';

import { ChevronRight, CloseIcon, Info, RedirectIcon } from '../../assets/icons';
import InitiateTransferModal from '../../pages/Account/Transaction/InitiateTransferModal';
import TransactionDetailsModal from '../../pages/Account/Transaction/TransactionDetailsModal';
import TransferCompleteModal from '../../pages/Account/Transaction/TransferCompleteModal';
import BankAccountModal from '../LinkBankAccount/BankAccountModal';

// import { NewTransfer } from '../../utils/constant';
import useMediaQuery from '../../Hooks/useMediaQuery';
import { getFundingSources } from '../../services/AccountApi/paymentMethodApi';
import { fetchPortfolioCardData } from '../../services/PortfolioApi/portfolioApi';
import { featchCashAndIncomeAction, featchLastDividendAction, fetchAccountValueDataAction } from '../../store/reducer/portfolioSlice';
import { getDateFormat } from '../../utils';
import { formatDate } from '../../utils/dateFormat.helper';
import { toastNotify } from '../../utils/toastNotify';
import { getUsCurrencyFormat, getUsPercentageFormat } from '../../utils/usCurrencyFormatter';

import { NOTIFICATION_MESSAGES } from '../../utils/constant';
import './PortfolioCard.scss';

const APPRECIATION_TYPE = {
  REALIZE: 'realize',
  UNREALIZE: 'unrealize',
};

const PortfolioCard = forwardRef(({ setLoading, isInvested }, ref) => {
  // const [navOpen, setNavOpen] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [transferCompleteModal, setTransferCompleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [initiateTransferedData, setInitiateTransferedData] = useState({});
  const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false);
  const [pendingModalTransactionData] = useState({});
  const [isDepositModal, setIsDepositModal] = useState(false);
  const [cardData, setcardData] = useState({
    allTimeDividends: '',
    appreciationPtage: '',
    appreciationValue: '',
    cashBalance: '',
    lastDividend: '',
    netAccountValue: '',
    nextPayout: '',
    lastDividendDate: '',
  });
  const [isBankInFundingSource, setIsBankInFundingSource] = useState(false);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const dispatch = useDispatch();
  const { accountValue, lastDividendData, cashAndIncome, loading } = useSelector((state) => state.portfolio);
  const userData = useSelector((state) => state.userData);
  let navigate = useNavigate();
  const cashModalContent = [
    <>
      {loading ? (
        <Spin className='w-100 text-center' spinning={loading} />
      ) : (
        <>
          <div className='ins-note'>
            Your account balance is determined by the sum of all dividends paid to you from properties in which you hold shares in, any uninvested
            cash in your Realbricks account, and any transfers made back to your bank.
          </div>
          <div className='net-value-wrap'>
            <Row className='net-value mb-8'>
              <Col span={14}>
                <span>Current cash balance</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(cashAndIncome?.data?.cashBalance)}`}</h4>
              </Col>
            </Row>
            <Row className='net-value mb-8'>
              <Col span={14}>
                <span></span>
              </Col>
              <Col
                span={10}
                onClick={() => {
                  setIsCashModalOpen(false);
                  setTransferModal(true);
                }}
                className='cursor-pointer'
              >
                <h4 className='transfer'>Transfer</h4>
              </Col>
            </Row>
          </div>
          <hr className='mb-40' />
          <div className='acc-value-wrap no-border'>
            <Row gutter={8} className='acc-value'>
              <Col span={16}>
                <span>Next dividend distribution date</span>
              </Col>
              <Col span={8}>
                <h4>{formatDate(cashAndIncome?.data?.nextDividendDate, 'MMM yyyy')}</h4>
              </Col>
            </Row>
            <Row gutter={8} className='acc-value'>
              <Col span={14}>
                <span>Next dividend amount</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(cashAndIncome?.data?.nextDividendAmount)}`}</h4>
              </Col>
            </Row>
          </div>
          <div className='note mt-48'>
            <p>
              * “Next dividend amount” is based on the previous dividend percentage for any asset you currently own. The previous dividend amount paid
              is not guaranteed, is determined at the sole discretion of Realbricks, and can change at any time without prior notice.
            </p>
          </div>
        </>
      )}
    </>,
  ];

  const dividendsModalContent = [
    <>
      {loading ? (
        <Spin className='w-100 text-center' spinning={loading} />
      ) : (
        <>
          <div className='ins-note'>
            Each share may distribute a dividend to its members based on its rental income performance. Dividends are expected to occur quarterly.
          </div>
          <div className='acc-value-wrap devidend-modal'>
            {/* Temporary Commented as per the CR changes */}
            {/* <Row gutter={8} className='acc-value'>
              <Col span={16}>
                <span>Your assets currently paying dividend</span>
              </Col>
              <Col span={8}>
                <h4>{`${lastDividendData?.data?.dividendPayingProperty} of ${lastDividendData?.data?.totalProperty}`}</h4>
              </Col>
            </Row> */}
            <Row gutter={8} className='acc-value'>
              <Col span={14}>
                <span>Last dividend total</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(lastDividendData?.data?.totalLastDividend)}`}</h4>
              </Col>
            </Row>
            <Row gutter={8} className='acc-value'>
              <Col span={14}>
                <span>Last dividend yield*</span>
              </Col>
              <Col span={10}>
                <h4>{`${getUsCurrencyFormat(lastDividendData?.data?.lastTotalDividendYield)}%`}</h4>
              </Col>
            </Row>
          </div>
          <div className='net-value-wrap'>
            <Row className='net-value mb-8'>
              <Col span={14}>
                <span>All time dividend earnings</span>
              </Col>
              <Col span={10}>
                <h4>{`$${getUsCurrencyFormat(lastDividendData?.data?.allTimeDividend)}`}</h4>
              </Col>
            </Row>
            <Row className='net-value mb-8'>
              <Col span={14}>
                <span>All time dividend yield</span>
              </Col>
              <Col span={10}>
                <h4>{`${getUsCurrencyFormat(lastDividendData?.data?.allTimeDividendYield)}%`}</h4>
              </Col>
            </Row>
          </div>
          <Button onClick={() => navigate('/account/transactions?transactionsType=dividend')} type='default w-100 mb-16'>
            View all dividend distributions
          </Button>
          <div className='note'>
            <p>* “Last Dividend yield” is the average yield percentage from properties in which you are a share holder.</p>
          </div>
        </>
      )}
    </>,
  ];
  // Destrucyture state
  const {
    allTimeDividends,
    appreciationPtage,
    appreciationValue,
    cashBalance,
    lastDividend,
    netAccountValue,
    nextPayout,
    allTimeDividendsPercentage,
  } = cardData;

  const handleBankAddSuccess = () => {
    setBankModalOpen(false);
    setIsBankInFundingSource(true);
    setTransferModal(true);
  };
  //API Integration Function
  const fetchCardData = async () => {
    try {
      setLoading(true);
      const cardDataResp = await fetchPortfolioCardData();
      const portFolioCardData = cardDataResp.data;
      if (!cardDataResp.isError) {
        setcardData(portFolioCardData);
      } else {
        toastNotify('error', cardDataResp?.message);
      }
      return portFolioCardData || null;
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const getFundingSourcesFun = async () => {
    try {
      const resp = await getFundingSources();
      if (!resp.isError) {
        const { banks } = resp.data;
        setIsBankInFundingSource(banks.length > 0);
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  };

  useImperativeHandle(ref, () => ({
    fetchCardData,
    transferCompleteModal,
  }));

  const showModal = async () => {
    setIsModalOpen(true);
    await dispatch(fetchAccountValueDataAction({}));
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [isTooltipModalOpen, setIsTooltipModalOpen] = useState('');
  const showTooltipModal = (value) => {
    setIsTooltipModalOpen(value);
  };
  const handleCancelTooltip = () => {
    setIsTooltipModalOpen('');
  };
  const [isDividendModalOpen, setIsDividendModalOpen] = useState(false);
  const showDividendModal = async () => {
    setIsDividendModalOpen(true);
    await dispatch(featchLastDividendAction({}));
  };
  const handleCancelDividend = () => {
    setIsDividendModalOpen(false);
  };
  const [isCashModalOpen, setIsCashModalOpen] = useState(false);
  const showCashModal = async () => {
    setIsCashModalOpen(true);
    await dispatch(featchCashAndIncomeAction({}));
  };
  const handleCancelCash = () => {
    setIsCashModalOpen(false);
  };
  const screenMD = useMediaQuery('(min-width: 1000px)');
  const handleInitiateTransfer = (val, isDeposit) => {
    if (!userData?.userData?.isDwollaVerified) {
      toastNotify('error', NOTIFICATION_MESSAGES.WARN_DWOLLA_PENDING);
      return;
    }
    if (val) {
      setIsDepositModal(isDeposit);
      setTransferModal(true);
    } else {
      userData?.userData?.isKYCVerified
        ? setBankModalOpen(true)
        : !userData?.userData?.isKYCVerified
        ? toastNotify('error', 'Please complete all your verification steps first.')
        : toastNotify('error', 'Your account is still in-review, you will be informed after completion of your account review.');
    }
  };

  useEffect(() => {
    getFundingSourcesFun();
  });

  return (
    <>
      <div className='portfoliocard'>
        <div className='container-fluid'>
          <Row gutter={[16, 16]}>
            <Col span={24} md={8}>
              <div className='portfoliocard__block'>
                <div className='portfoliocard__inner'>
                  <h4>Net Account Value</h4>
                </div>
                <div className='portfoliocard__onevalue'>${getUsCurrencyFormat(netAccountValue)} </div>
                {Number(netAccountValue) !== 0 ? (
                  <div className='portfoliocard__alltimevalue inner-btn'>
                    <div className='value'>
                      {Number(appreciationValue) < 0 ? '-' : ''}$
                      {getUsCurrencyFormat(Number(appreciationValue) < 0 ? -Number(appreciationValue) : Number(appreciationValue) || 0)}
                      <span className={Number(appreciationValue) < 0 ? 'error' : 'success'}>
                        ({Number(appreciationPtage) > 0 ? '+' : ''}
                        {getUsCurrencyFormat(Number(appreciationPtage) || 0)}%)
                      </span>
                    </div>
                    <div className='head'>P & L</div>
                    <span onClick={showModal} className='redirect cursor-pointer'>
                      <RedirectIcon verticalAlign='middle' color='#958B88' size='30' />
                    </span>
                  </div>
                ) : (
                  <div className='portfoliocard__novalue'>
                    The net value of your account is calculated by aggregating the value of all your purchased shares, in addition to any declared but
                    unpaid dividends.
                  </div>
                )}
              </div>
            </Col>
            <Col span={24} md={8}>
              <div className='portfoliocard__block'>
                <div className='portfoliocard__inner'>
                  <h4>Last Dividend</h4>
                </div>
                <div className='portfoliocard__onevalue'>
                  {Number(lastDividend) < 0 ? '-' : ''}$
                  {getUsCurrencyFormat(Number(lastDividend) < 0 ? -Number(lastDividend) : Number(lastDividend) || 0)}
                </div>
                {Number(lastDividend) !== 0 ? (
                  <div className='portfoliocard__alltimevalue inner-btn'>
                    <div className='value'>
                      {Number(allTimeDividends) < 0 ? '-' : ''}$
                      {getUsCurrencyFormat(Number(allTimeDividends) < 0 ? -Number(allTimeDividends) : Number(allTimeDividends) || 0)}
                      <span>({getUsPercentageFormat(Number(allTimeDividendsPercentage) || 0)}% avg)</span>
                    </div>
                    <div className='head'>Total dividends paid</div>
                    <span onClick={showDividendModal} className='redirect cursor-pointer'>
                      <RedirectIcon verticalAlign='middle' color='#958B88' size='30' />
                    </span>
                  </div>
                ) : (
                  <div className='portfoliocard__novalue'>
                    Each share may distribute a dividend to its members based on its rental income performance. Dividends are expected to occur
                    quarterly.
                  </div>
                )}
              </div>
            </Col>
            <Col span={24} md={8}>
              <div className='portfoliocard__block'>
                <div className='portfoliocard__inner'>
                  <h4 className='w-100 d-flex'>
                    <span>Account Deposit Balance</span>
                    {Number(cashBalance) > 0 ? (
                      <span className='cursor-pointer ml-8 transfer' onClick={() => handleInitiateTransfer(isBankInFundingSource, false)}>
                        Transfer
                      </span>
                    ) : (
                      <span className='cursor-pointer ml-auto transfer' onClick={() => handleInitiateTransfer(isBankInFundingSource, true)}>
                        Deposit funds <ChevronRight verticalAlign='-5px' size={20} />{' '}
                      </span>
                    )}
                  </h4>
                </div>
                <div className='portfoliocard__onevalue'>
                  ${getUsCurrencyFormat(Number(cashBalance) < 0 ? -Number(cashBalance) : Number(cashBalance) || 0)}
                </div>
                {Number(cashBalance) !== 0 && isInvested ? (
                  <div className='portfoliocard__alltimevalue inner-btn'>
                    <div className='value'>
                      {getDateFormat({
                        date: new Date(nextPayout) || '',
                        options: {
                          month: 'long',
                        },
                      })}
                      <span> </span>
                    </div>
                    <div className='head'>Next dividend date</div>
                    <span onClick={showCashModal} className='redirect cursor-pointer'>
                      <RedirectIcon verticalAlign='middle' color='#958B88' size='30' />
                    </span>
                  </div>
                ) : (
                  <div className='portfoliocard__novalue'>
                    Your account balance is determined by the sum of all dividends paid to you from properties in which you hold shares in, any
                    uninvested cash in your Realbricks account, and any transfers made back to your bank.
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {transferModal && (
        <InitiateTransferModal
          isTransferModalOpen={transferModal}
          closeTransferModal={() => setTransferModal()}
          openTransferCompleteModal={setTransferCompleteModal}
          initiateTransferedData={setInitiateTransferedData}
          // modalType={NewTransfer.Portfolio}
          isDepositModal={isDepositModal}
        />
      )}
      {transferCompleteModal && (
        <TransferCompleteModal
          transferCompleteModal={transferCompleteModal}
          setTransferCompleteModal={() => {
            setTransferCompleteModal();
            fetchCardData();
          }}
          setTransactionDetailsOpen={() => setTransactionDetailsOpen()}
          openInitiateTransfer={() => setTransferModal(true)}
          initiateTransferedData={initiateTransferedData}
        />
      )}
      {transactionDetailsOpen && (
        <TransactionDetailsModal
          transactionDetailsOpen={transactionDetailsOpen}
          setTransactionDetailsOpen={() => setTransactionDetailsOpen()}
          modalTransactionData={pendingModalTransactionData}
        />
      )}
      {bankModalOpen && (
        <BankAccountModal
          bankModalOpen={bankModalOpen}
          setBankModalOpen={(value) => setBankModalOpen(value)}
          onSuccess={() => handleBankAddSuccess()}
          onClose={(value) => setBankModalOpen(false)}
        />
      )}
      {screenMD ? (
        <Modal
          title='Net Account Value'
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          header={null}
          className='portfolio-overview-modals newaccount-popup'
        >
          <>
            {loading ? (
              <Spin className='w-100 text-center' spinning={loading} />
            ) : (
              <>
                <div className='ins-note'>
                  The net value of your account is calculated by aggregating the value of all your purchased shares, in addition to any declared but
                  unpaid dividends.
                </div>
                <div className='acc-value-wrap'>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>Net Account Value(NAV)</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.netAccountValue)}`}</h4>
                    </Col>
                  </Row>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>Cash balance</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.cashBalance)}`}</h4>
                    </Col>
                  </Row>
                </div>
                <div className='net-value-wrap'>
                  <Row className='net-value'>
                    <Col span={14}>
                      <span>Total Account Value*</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.totalAccountValue)}`}</h4>
                    </Col>
                  </Row>
                </div>
                <div className='acc-value-wrap'>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>All time contributions</span>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.allTimeContribution)}`}</h4>
                    </Col>
                  </Row>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <Tooltip title='The appreciation returns rewarded to you after selling your shares for cash.'>
                        <span className='acc-value-label tooltip'>
                          Realized share appreciation
                          <span>
                            <Info marginLeft='8px' verticalAlign='middle' />
                          </span>
                        </span>
                      </Tooltip>
                    </Col>
                    <Col span={10}>
                      <h4>{`$${getUsCurrencyFormat(accountValue?.data?.realizedGain)}`}</h4>
                    </Col>
                  </Row>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <Tooltip title='The increase in the value of all asset shares you own that has yet to be sold for cash.'>
                        <span className='acc-value-label tooltip'>
                          Unrealized share appreciation
                          <span>
                            <Info marginLeft='8px' verticalAlign='middle' />
                          </span>
                        </span>
                      </Tooltip>
                    </Col>
                    <Col span={10}>
                      <h4>
                        {`${Number(accountValue?.data?.unrealizedAppreciation) < 0 ? '-' : '+'} $${
                          Number(accountValue?.data?.unrealizedAppreciation) < 0
                            ? getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation?.toString()?.slice(1))
                            : getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation)
                        }`}
                      </h4>
                    </Col>
                  </Row>
                  <Row gutter={8} className='acc-value'>
                    <Col span={14}>
                      <span>Total dividends received</span>
                    </Col>
                    <Col span={10}>
                      <h4>
                        {`${Number(accountValue?.data?.totalDividend) < 0 ? '-' : '+'} $${
                          Number(accountValue?.data?.totalDividend) < 0
                            ? getUsCurrencyFormat(accountValue?.data?.totalDividend?.toString()?.slice(1))
                            : getUsCurrencyFormat(accountValue?.data?.totalDividend)
                        }`}
                      </h4>
                    </Col>
                  </Row>
                </div>
                <div className='net-value-wrap'>
                  <Row className='net-value'>
                    <Col span={14}>
                      <span>All time gain*</span>
                    </Col>
                    <Col span={10}>
                      <h4>
                        {`${Number(accountValue?.data?.allTimeGain) < 0 ? '-' : '+'} $${
                          Number(accountValue?.data?.allTimeGain) < 0
                            ? getUsCurrencyFormat(accountValue?.data?.allTimeGain?.toString()?.slice(1))
                            : getUsCurrencyFormat(accountValue?.data?.allTimeGain)
                        }`}
                      </h4>
                    </Col>
                  </Row>
                </div>
                <div className='note'>
                  <p>
                    * “Total account value” and “All time gain” metrics include the value of owned property shares that have not yet been sold. Unsold
                    shares can vary in price at anytime and will effect these calculations.
                  </p>
                </div>
              </>
            )}
          </>
        </Modal>
      ) : (
        <>
          <Drawer
            className='portfolio-overview-modals footer-shadow quickbuy--drawer'
            width='100%'
            onClose={handleCancel}
            open={isModalOpen}
            closeIcon={<CloseIcon />}
            title='Net Account Value'
            footer={false}
          >
            <>
              {loading ? (
                <Spin className='w-100 text-center' spinning={loading} />
              ) : (
                <>
                  <div className='ins-note'>
                    The net value of your account is calculated by aggregating the value of all your purchased shares, in addition to any declared but
                    unpaid dividends.
                  </div>
                  <div className='acc-value-wrap'>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>Total value of owned shares</span>
                      </Col>
                      <Col span={10}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.totalAccountValue)}`}</h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>Cash balance</span>
                      </Col>
                      <Col span={10}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.cashBalance)}`}</h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='net-value-wrap'>
                    <Row className='net-value'>
                      <Col span={10}>
                        <span>Total Account Value*</span>
                      </Col>
                      <Col span={14}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.netAccountValue)}`}</h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='acc-value-wrap'>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>All time contributions</span>
                      </Col>
                      <Col span={10}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.allTimeContribution)}`}</h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span onClick={() => showTooltipModal(APPRECIATION_TYPE.REALIZE)} className='acc-value-label tooltip'>
                          Realized share appreciation
                        </span>
                      </Col>
                      <Col span={10}>
                        <h4>
                          {`${Number(accountValue?.data?.realizedGain) < 0 ? '-' : '+'} $${
                            Number(accountValue?.data?.realizedGain) < 0
                              ? getUsCurrencyFormat(accountValue?.data?.realizedGain?.toString()?.slice(1))
                              : getUsCurrencyFormat(accountValue?.data?.realizedGain)
                          }`}
                        </h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span onClick={() => showTooltipModal(APPRECIATION_TYPE.UNREALIZE)} className='acc-value-label tooltip'>
                          Unrealized share appreciation
                        </span>
                      </Col>
                      <Col span={10}>
                        <h4>
                          {`${Number(accountValue?.data?.unrealizedAppreciation) < 0 ? '-' : '+'} $${
                            Number(accountValue?.data?.unrealizedAppreciation) < 0
                              ? getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation?.toString()?.slice(1))
                              : getUsCurrencyFormat(accountValue?.data?.unrealizedAppreciation)
                          }`}
                        </h4>
                      </Col>
                    </Row>
                    <Row gutter={8} className='acc-value'>
                      <Col span={14}>
                        <span>Total dividends received</span>
                      </Col>
                      <Col span={10}>
                        <h4>
                          {`${Number(accountValue?.data?.totalDividend) < 0 ? '-' : '+'} $${
                            Number(accountValue?.data?.totalDividend) < 0
                              ? getUsCurrencyFormat(accountValue?.data?.totalDividend?.toString()?.slice(1))
                              : getUsCurrencyFormat(accountValue?.data?.totalDividend)
                          }`}
                        </h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='net-value-wrap'>
                    <Row className='net-value'>
                      <Col span={10}>
                        <span>All time gain*</span>
                      </Col>
                      <Col span={14}>
                        <h4>{`$${getUsCurrencyFormat(accountValue?.data?.allTimeGain)}`}</h4>
                      </Col>
                    </Row>
                  </div>
                  <div className='note'>
                    <p>
                      * “Total account value” and “All time gain” metrics include the value of owned property shares that have not yet been sold.
                      Unsold shares can vary in price at anytime and will effect these calculations.
                    </p>
                  </div>
                </>
              )}
            </>
          </Drawer>
          <Modal
            open={isTooltipModalOpen === APPRECIATION_TYPE.REALIZE}
            onCancel={handleCancelTooltip}
            footer={null}
            header={null}
            width={272}
            className='tooltip-modals'
            centered
          >
            <h4>Realized shares appreciation</h4>
            <div className='ins-note'>The appreciation returns rewarded to you after selling your shares for cash.</div>
          </Modal>
          <Modal
            open={isTooltipModalOpen === APPRECIATION_TYPE.UNREALIZE}
            onCancel={handleCancelTooltip}
            footer={null}
            header={null}
            width={272}
            className='tooltip-modals'
            centered
          >
            <h4>Unrealized share appreciation</h4>
            <div className='ins-note'>The increase in the value of all asset shares you own that has yet to be sold for cash.</div>
          </Modal>
        </>
      )}

      {screenMD ? (
        <Modal
          title='Last Dividend'
          open={isDividendModalOpen}
          onCancel={handleCancelDividend}
          footer={null}
          header={null}
          className='portfolio-overview-modals newaccount-popup'
        >
          {dividendsModalContent}
        </Modal>
      ) : (
        <Drawer
          className='portfolio-overview-modals footer-shadow quickbuy--drawer'
          width='100%'
          onClose={handleCancelDividend}
          open={isDividendModalOpen}
          closeIcon={<CloseIcon />}
          footer={false}
          title='Last Dividend'
        >
          {dividendsModalContent}
        </Drawer>
      )}

      {screenMD ? (
        <Modal
          title='Account Deposit Balance'
          open={isCashModalOpen}
          onCancel={handleCancelCash}
          footer={null}
          header={null}
          className='portfolio-overview-modals newaccount-popup'
        >
          {cashModalContent}
        </Modal>
      ) : (
        <Drawer
          className='portfolio-overview-modals footer-shadow quickbuy--drawer'
          width='100%'
          onClose={handleCancelCash}
          open={isCashModalOpen}
          closeIcon={<CloseIcon />}
          footer={false}
          title='Account Deposit Balance'
        >
          {cashModalContent}
        </Drawer>
      )}
    </>
  );
});

export default PortfolioCard;
